module.exports = __webpack_public_path__ + "static/media/inbox.c91a7ae3.svg";